import { Loan } from '../types/conditions'

export const mockLoans: Loan[] = [
  {
    id: 'L-1001',
    borrowerName: 'Sarah Jenkins',
    loanNumber: '100492810',
    loanAmount: 450000,
    propertyAddress: '124 Maple Street, Seattle, WA 98101',
    stage: 'Processing',
    conditions: [
      {
        id: 'C-101',
        title: 'Most Recent Pay Stub',
        category: 'Income',
        status: 'Review',
        comments: [
          {
            id: 'CM-1',
            authorName: 'Sarah Jenkins',
            authorRole: 'Borrower',
            timestamp: '2023-10-24T14:30:00Z',
            message:
              'I uploaded my paystub from last week. Let me know if you need the one before that too.',
            visibility: 'Public',
            isRead: false,
          },
        ],
        documents: [
          {
            id: 'D-1',
            filename: 'Jenkins_Paystub_Oct2023.pdf',
            fileType: 'pdf',
            size: '1.2 MB',
            uploadedDate: '2023-10-24T14:28:00Z',
            uploadedBy: 'Sarah Jenkins',
            status: 'Pending',
          },
        ],
      },
      {
        id: 'C-102',
        title: '2022 W-2',
        category: 'Income',
        status: 'Needs Info',
        comments: [
          {
            id: 'CM-2',
            authorName: 'Michael Chang',
            authorRole: 'Underwriter',
            timestamp: '2023-10-23T09:15:00Z',
            message:
              'The uploaded W-2 is blurry and I cannot read the employer EIN. Please request a clearer copy.',
            visibility: 'Private',
            isRead: true,
          },
          {
            id: 'CM-3',
            authorName: 'Sarah Jenkins',
            authorRole: 'Borrower',
            timestamp: '2023-10-24T16:45:00Z',
            message:
              'Sorry about that, I just uploaded a new scan. Is this one better?',
            visibility: 'Public',
            isRead: false,
          },
        ],
        documents: [
          {
            id: 'D-2',
            filename: 'W2_2022_Blurry.pdf',
            fileType: 'pdf',
            size: '800 KB',
            uploadedDate: '2023-10-22T11:00:00Z',
            uploadedBy: 'Sarah Jenkins',
            status: 'Rejected',
          },
          {
            id: 'D-3',
            filename: 'W2_2022_ClearScan.pdf',
            fileType: 'pdf',
            size: '2.1 MB',
            uploadedDate: '2023-10-24T16:44:00Z',
            uploadedBy: 'Sarah Jenkins',
            status: 'Pending',
          },
        ],
      },
      {
        id: 'C-103',
        title: 'Driver\u2019s License',
        category: 'Credit',
        status: 'Approved',
        comments: [],
        documents: [
          {
            id: 'D-103-1',
            filename: 'Jenkins_DL_Front.pdf',
            fileType: 'pdf',
            size: '420 KB',
            uploadedDate: '2023-10-20T09:10:00Z',
            uploadedBy: 'Sarah Jenkins',
            status: 'Approved',
          },
        ],
      },
      {
        id: 'C-104',
        title: 'Verification of Employment',
        category: 'Income',
        status: 'Review',
        comments: [
          {
            id: 'CM-104-1',
            authorName: 'Jessica Smith',
            authorRole: 'Processor',
            timestamp: '2023-10-25T08:00:00Z',
            message: 'VOE form sent to employer, awaiting return.',
            visibility: 'Private',
            isRead: true,
          },
        ],
        documents: [],
      },
      {
        id: 'C-105',
        title: 'Credit Explanation Letter',
        category: 'Credit',
        status: 'Review',
        comments: [],
        documents: [],
      },
    ],
  },
  {
    id: 'L-1002',
    borrowerName: 'David & Maria Rodriguez',
    loanNumber: '100492844',
    loanAmount: 625000,
    propertyAddress: '8890 Oak Avenue, Austin, TX 78704',
    stage: 'Underwriting',
    conditions: [
      {
        id: 'C-201',
        title: 'Proof of Homeowners Insurance',
        category: 'Property',
        status: 'Review',
        comments: [],
        documents: [
          {
            id: 'D-4',
            filename: 'StateFarm_Policy_Decs.pdf',
            fileType: 'pdf',
            size: '3.4 MB',
            uploadedDate: '2023-10-25T08:20:00Z',
            uploadedBy: 'David Rodriguez',
            status: 'Pending',
          },
        ],
      },
      {
        id: 'C-202',
        title: 'Letter of Explanation - Large Deposit',
        category: 'Asset',
        status: 'Review',
        comments: [
          {
            id: 'CM-4',
            authorName: 'David Rodriguez',
            authorRole: 'Borrower',
            timestamp: '2023-10-25T10:05:00Z',
            message:
              'I wrote a quick note explaining the $15,000 deposit. It was a gift from my parents for the down payment. Do you need them to sign a gift letter too?',
            visibility: 'Public',
            isRead: false,
          },
        ],
        documents: [],
      },
      {
        id: 'C-203',
        title: 'Appraisal Report',
        category: 'Property',
        status: 'Approved',
        comments: [
          {
            id: 'CM-5',
            authorName: 'Jessica Smith',
            authorRole: 'Processor',
            timestamp: '2023-10-24T13:00:00Z',
            message: 'Appraisal came back at value. No repairs required.',
            visibility: 'Private',
            isRead: true,
          },
        ],
        documents: [
          {
            id: 'D-5',
            filename: 'Appraisal_8890_Oak.pdf',
            fileType: 'pdf',
            size: '12.5 MB',
            uploadedDate: '2023-10-24T12:55:00Z',
            uploadedBy: 'Jessica Smith',
            status: 'Approved',
          },
        ],
      },
      {
        id: 'C-204',
        title: 'Gift Letter - Down Payment',
        category: 'Asset',
        status: 'Review',
        comments: [
          {
            id: 'CM-204-1',
            authorName: 'Maria Rodriguez',
            authorRole: 'Borrower',
            timestamp: '2023-10-25T11:00:00Z',
            message: 'My parents signed the gift letter. Attaching it here.',
            visibility: 'Public',
            isRead: false,
          },
        ],
        documents: [
          {
            id: 'D-204-1',
            filename: 'Gift_Letter_Signed.pdf',
            fileType: 'pdf',
            size: '320 KB',
            uploadedDate: '2023-10-25T11:01:00Z',
            uploadedBy: 'Maria Rodriguez',
            status: 'Pending',
          },
        ],
      },
      {
        id: 'C-205',
        title: 'Title Commitment',
        category: 'Property',
        status: 'Review',
        comments: [],
        documents: [],
      },
      {
        id: 'C-206',
        title: 'Termite Inspection Report',
        category: 'Property',
        status: 'Needs Info',
        comments: [
          {
            id: 'CM-206-1',
            authorName: 'Michael Chang',
            authorRole: 'Underwriter',
            timestamp: '2023-10-23T15:00:00Z',
            message:
              'Inspector flagged minor activity in garage. Need treatment receipt before clearing.',
            visibility: 'Private',
            isRead: true,
          },
        ],
        documents: [],
      },
    ],
  },
  {
    id: 'L-1003',
    borrowerName: 'Robert Chen',
    loanNumber: '100493102',
    loanAmount: 310000,
    propertyAddress: '45B Pine Lane, Denver, CO 80202',
    stage: 'Clear to Close',
    conditions: [
      {
        id: 'C-301',
        title: 'Updated Bank Statements',
        category: 'Asset',
        status: 'Review',
        comments: [
          {
            id: 'CM-6',
            authorName: 'Robert Chen',
            authorRole: 'Borrower',
            timestamp: '2023-10-25T11:30:00Z',
            message: 'Here are the October statements you asked for.',
            visibility: 'Public',
            isRead: false,
          },
        ],
        documents: [
          {
            id: 'D-6',
            filename: 'Chase_Checking_Oct.pdf',
            fileType: 'pdf',
            size: '1.8 MB',
            uploadedDate: '2023-10-25T11:28:00Z',
            uploadedBy: 'Robert Chen',
            status: 'Pending',
          },
          {
            id: 'D-7',
            filename: 'Chase_Savings_Oct.pdf',
            fileType: 'pdf',
            size: '1.5 MB',
            uploadedDate: '2023-10-25T11:29:00Z',
            uploadedBy: 'Robert Chen',
            status: 'Pending',
          },
        ],
      },
      {
        id: 'C-302',
        title: '401(k) Statement',
        category: 'Asset',
        status: 'Review',
        comments: [],
        documents: [
          {
            id: 'D-302-1',
            filename: 'Fidelity_401k_Q3.pdf',
            fileType: 'pdf',
            size: '900 KB',
            uploadedDate: '2023-10-25T09:00:00Z',
            uploadedBy: 'Robert Chen',
            status: 'Pending',
          },
        ],
      },
      {
        id: 'C-303',
        title: 'Final Closing Disclosure Acknowledgment',
        category: 'General',
        status: 'Review',
        comments: [],
        documents: [],
      },
      {
        id: 'C-304',
        title: 'Homeowners Insurance Binder',
        category: 'Property',
        status: 'Approved',
        comments: [],
        documents: [
          {
            id: 'D-304-1',
            filename: 'Allstate_Binder.pdf',
            fileType: 'pdf',
            size: '1.1 MB',
            uploadedDate: '2023-10-22T10:00:00Z',
            uploadedBy: 'Robert Chen',
            status: 'Approved',
          },
        ],
      },
      {
        id: 'C-305',
        title: 'Identity Verification',
        category: 'Credit',
        status: 'Approved',
        comments: [],
        documents: [],
      },
    ],
  },
]
